module.exports = __webpack_public_path__ + "img/mapicon.198c04ad.png";